import React, { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Loading, EmptyState } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ClipboardCheck } from "lucide-react";
import DpQcDialog from "./DpQcDialog";

const typeBadge = (j) => j.job_type === "INTERNAL"
  ? <Badge variant="outline" className="border-violet-200 bg-violet-50 text-violet-700">INTERNAL</Badge>
  : j.sales_channel === "ONLINE"
    ? <Badge variant="outline" className="border-sky-200 bg-sky-50 text-sky-700">ONLINE EXTERNAL</Badge>
    : <Badge variant="outline" className="border-amber-200 bg-amber-50 text-amber-700">OFFLINE EXTERNAL</Badge>;

export default function DpQc() {
  const { can } = useAuth();
  const [rows, setRows] = useState(null);
  const [reasons, setReasons] = useState([]);
  const [qcJob, setQcJob] = useState(null);

  const load = useCallback(() => {
    api.get("/digital-printing/production/queue", { params: { status: "QC" } }).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);
  useEffect(() => {
    api.get("/digital-printing/production/meta").then((r) => setReasons(r.data.qc_reasons || [])).catch(() => {});
    load();
  }, [load]);

  if (!rows) return <Loading />;

  return (
    <div data-testid="dp-qc">
      <PageHeader title="QC Digital Printing" subtitle="Antrean Job yang menunggu Quality Control. PASS → Completed, REJECT → Rework / Final Reject." />

      {rows.length === 0 ? (
        <EmptyState title="Tidak ada Job menunggu QC" subtitle="Job akan muncul di sini setelah seluruh production step selesai." icon={ClipboardCheck} />
      ) : (
        <Card className="overflow-x-auto p-0">
          <table className="w-full text-sm">
            <thead><tr className="border-b text-left text-xs text-slate-400">
              <th className="p-3">Job Number</th><th>Tipe</th><th>Layanan</th><th className="text-right">Batch Qty</th><th>Cycle</th><th>Sumber/Customer</th><th></th>
            </tr></thead>
            <tbody>
              {rows.map((j) => (
                <tr key={j.id} data-testid={`qc-row-${j.id}`} className="border-b hover:bg-slate-50">
                  <td className="p-3 font-mono text-xs">{j.job_number}</td>
                  <td>{typeBadge(j)}</td>
                  <td className="text-xs">{j.service_snapshot?.service_name}</td>
                  <td className="text-right">{j.active_batch_qty ?? j.quantity} {j.unit}</td>
                  <td className="text-xs">{j.cycle || 0}</td>
                  <td className="text-xs text-slate-600">{j.source_store_name || j.customer_name || j.source_business_unit || "—"}</td>
                  <td className="text-right">
                    {can("digital_printing.qc.inspect") && <Button size="sm" className="bg-amber-600 hover:bg-amber-500" onClick={() => setQcJob(j)} data-testid={`qc-inspect-${j.id}`}>Inspeksi QC</Button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}

      {qcJob && <DpQcDialog job={qcJob} reasons={reasons} onClose={() => setQcJob(null)} onDone={() => { setQcJob(null); load(); }} />}
    </div>
  );
}
